module.exports = __webpack_public_path__ + "img/rajput_electricals.8f92e759.jpg";